import { getVariantPrice, getAvailableVariantStock } from "@modules/product-helper";

export default {
    props: {
        translations: {
            type: Object,
            required: true
        }
    },

    methods: {
        updateAmount(event, product) {
            const newValue = parseInt(event.target.value);

            if (newValue >= 1 && newValue <= getAvailableVariantStock(product.variant)) {
                this.$store.dispatch("updateProductAmount", {
                    variant_id: product.variant.id,
                    amount: newValue
                });
            } else {
                this.$store.dispatch("updateProductAmount", {
                    variant_id: product.variant.id,
                    amount: product.amount
                });
                event.target.value = product.amount;
            }
        },

        decreaseAmount(product) {
            const newValue = parseInt(product.amount) - 1;

            if (newValue >= 1) {
                this.$store.dispatch("updateProductAmount", {
                    variant_id: product.variant.id,
                    amount: newValue
                });
            }
        },

        increaseAmount(product) {
            const newValue = parseInt(product.amount) + 1;

            if (newValue <= getAvailableVariantStock(product.variant)) {
                this.$store.dispatch("updateProductAmount", {
                    variant_id: product.variant.id,
                    amount: newValue
                });
            }
        },

        removeProduct(variant_id) {
            this.$store.dispatch("deleteProduct", variant_id);
        },

        getFirstImage(product) {
            let image = "";
            if (product.media != null && product.media.length > 0) {
                product.media.forEach(m => {
                    if (m.type.indexOf("link") < 0 && image == "") {
                        image = m.path;
                    }
                });
            }
            return image;
        },

        getVariantPrice(product, vat_incl = false) {
            return getVariantPrice(product, vat_incl);
        },

        getAvailableVariantStock(variant) {
            return getAvailableVariantStock(variant);
        },

        formatCurrency(amount) {
            let val = (amount / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        truncate(input) {
            if (input.length > 5) {
                return input.substring(0, 5) + "...";
            }
            return input;
        }
    },

    computed: {
        basket() {
            return this.$store.getters["basket"];
        },

        subTotal() {
            let subTotal = this.$store.getters["subTotal"];

            return this.formatCurrency(subTotal);
        },

        vat() {
            let vat = this.$store.getters["vat"];

            return this.formatCurrency(vat);
        },

        totalPrice() {
            let totalPrice = this.$store.getters["totalPrice"];

            return this.formatCurrency(totalPrice);
        }
    }
};
